'use client';

export { ReactComponent as TrustpilotLogo } from './trustpilot-logo.svg';
export { ReactComponent as GoogleLogo } from './google-logo.svg';
